import "./App.css";
import CaseDetails from "./pages/CaseDetails/CaseDetails";
import Navbar from "./components/Navbar/Navbar";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Caselist from "./pages/CaseList/CaseList";
import Profile from "./components/Profile/Profile";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import Test from "./components/Test/Test";
import Download from "./components/Download/Download";
import SSOPage from "./components/SSOPage/SSOPage";
import InitialCaseDetails from "./components/InitialCaseDetails/InitialCaseDetails";
import PackageMapping from "./pages/PackageMapping/PackageMapping";
import KnowledgeBase from "./pages/KnowledgeBase/KnowledgeBase";
import Dashboard from "./pages/Dashboard/Dashboard";
import InsuranceCaselist from "./pages/InsuranceCaseList/InsuranceCaseList";
import CaseListFiltersProvider from "./components/StateManagement/caseListfiltersContext";
import MasterControl from "./pages/MasterControl/MasterControl";
import UserOnboarding from "./pages/UserOnboarding/UserOnboarding";
import MISComputation from "./pages/MISComputation/MISComputation";
function App() {
  const role = localStorage.getItem("role");
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUserDetails"));
  function isLoggedIn() {
    let authenticated =
      localStorage.getItem("isLoggedIn") === "true" ? true : false;
    return authenticated;
  }

  return (
    <Router>
      <div className="App">
        <Navbar role={role} />
        <Switch>
          <Route exact path="/">
            {isLoggedIn() ? (
              <Redirect to="/profiles" />
            ) : (
              <Redirect to="/sso" />
            )}
          </Route>
          <Route exact path="/userOnboarding">
            {isLoggedIn() ? (
              role === "Admin" ? (
                <UserOnboarding />
              ) : (
                <div style={{ margin: "25%", textAlign: "center" }}>
                  <h2>You do not have access to view this page.</h2>
                </div>
              )
            ) : (
              <Redirect to="/sso" />
            )}
          </Route>
          <Route exact path="/packageMapping">
            {isLoggedIn() ? (
              role === "Admin" ? (
                <PackageMapping />
              ) : (
                <div style={{ margin: "25%", textAlign: "center" }}>
                  <h2>You do not have access to view this page.</h2>
                </div>
              )
            ) : (
              <Redirect to="/sso" />
            )}
          </Route>
          <Route exact path="/knowledgeBase">
            {isLoggedIn() ? (
              loggedInUser.isTechTeam ? (
                <KnowledgeBase />
              ) : (
                <div style={{ margin: "25%", textAlign: "center" }}>
                  <h2>You do not have access to view this page.</h2>
                </div>
              )
            ) : (
              <Redirect to="/sso" />
            )}
          </Route>
          <Route exact path="/masterControl">
            {isLoggedIn() ? (
              role === "Admin" ? (
                <MasterControl />
              ) : (
                <div style={{ margin: "25%", textAlign: "center" }}>
                  <h2>You do not have access to view this page.</h2>
                </div>
              )
            ) : (
              <Redirect to="/sso" />
            )}
          </Route>
          <Route exact path="/MISComputation">
            {isLoggedIn() ? (
              role === "Admin" ? (
                <MISComputation />
              ) : (
                <div style={{ margin: "25%", textAlign: "center" }}>
                  <h2>You do not have access to view this page.</h2>
                </div>
              )
            ) : (
              <Redirect to="/sso" />
            )}
          </Route>
          <Route exact path="/profiles">
            {isLoggedIn() ? <Profile /> : <Redirect to="/sso" />}
          </Route>
          <Route path="/dashboard">
            {isLoggedIn() ? <Dashboard /> : <Redirect to="/sso" />}
          </Route>
          {/* <Route path="/apiresponses">
              <Caselist/>
          </Route> */}
          <Route path="/test">
            {isLoggedIn() ? <Test /> : <Redirect to="/sso" />}
          </Route>
          <Route path={`/initialcases/:caseId`}>
            {isLoggedIn() ? <InitialCaseDetails /> : <Redirect to="/sso" />}
          </Route>
          <Route exact path="/sso">
            <SSOPage />
          </Route>
          <CaseListFiltersProvider>
            <Route path="/docs">
              {isLoggedIn() ? <Caselist role={role} /> : <Redirect to="/sso" />}
            </Route>
            <Route path="/corporatecaselist">
              {isLoggedIn() ? <Caselist role={role} /> : <Redirect to="/sso" />}
            </Route>
            <Route path={`/cases/:caseId`}>
              {isLoggedIn() ? (
                <CaseDetails role={role} />
              ) : (
                <Redirect to="/sso" />
              )}
            </Route>
            <Route path={`/profiles/:profile`}>
              {isLoggedIn() ? <Caselist role={role} /> : <Redirect to="/sso" />}
            </Route>
            <Route path="/insurancecaselist">
              {isLoggedIn() ? <Caselist role={role} /> : <Redirect to="/sso" />}
            </Route>
            <Route path="/download">
            {isLoggedIn() ? (
                role === "Admin" ? (
                  <Download />
                ) : (
                  <div style={{ margin: "25%", textAlign: "center" }}>
                    <h2>You do not have access to view this page.</h2>
                  </div>
                )
              ) : (
                <Redirect to="/sso" />
              )}
            </Route>
          </CaseListFiltersProvider>
          <Route path="*">
            <ErrorPage />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
